import React, {Component, createRef} from "react";
import { connect } from 'react-redux';
import Input from '../../components/UI/Input/Input';
import Button from '../../components/UI/Button/Button';
import Spinner from '../../components/UI/Spinner/Spinner';
import './Auth.css';
import * as actions from '../../store/actions/index';
import { updateObject, checkValidity } from '../../shared/utility';
import classes from "../GamesReference/GamesReference.module.css";
import apiUrl from "../../shared/config";

class Auth extends Component {
    state = {
        controls: {
            email: {
                elementType: 'input',
                elementConfig: {
                    type: 'email',
                    placeholder: 'Email Address'
                },
                value: '',
                validation: {
                    required: true,
                    isEmail: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            },
            password: {
                elementType: 'input',
                elementConfig: {
                    type: 'password',
                    placeholder: 'Password'
                },
                value: '',
                validation: {
                    required: true,
                    minLength: 6
                },
                valid: false,
                touched: false
            }
        },
        isSignup: false,
        isPasswordReset: false
    };

    focusRef = createRef()

    inputChangedHandler = ( event, controlName ) => {
        const updatedControls = updateObject( this.state.controls, {
            [controlName]: updateObject( this.state.controls[controlName], {
                value: event.target.value,
                valid: checkValidity( event.target.value, this.state.controls[controlName].validation ),
                touched: true
            } )
        } );
        this.setState( { controls: updatedControls } );
    };

    submitHandler = ( event ) => {
        event.preventDefault();
        this.props.onAuth( this.state.controls.email.value, this.state.controls.password.value, this.state.isSignup );
    };

    submitPasswordResetHandler = ( event ) => {
        event.preventDefault();
        this.props.onPasswordResetRequest( this.state.controls.email.value );
        this.switchAuthModeHandler(event)
    };

    switchAuthModeHandler = ( event ) => {
        event.preventDefault();
        this.setState( prevState => {
            return {
                isSignup: !prevState.isSignup,
                isPasswordReset: false
            };
        } );
    };

    passwordResetHandlerMode = (event ) => {
        event.preventDefault();
        this.setState( prevState => {
            return {
                isPasswordReset: !prevState.isPasswordReset,
                isSignup: true //This won't cause a new signup on submit, but in forces the 'switch to' button to go to login.
            };
        } );
    };

    backToLogin = () => {
        this.props.onBackToLogin();
    }

    render() {
        const formElementsArray = [];
        if (this.state.isPasswordReset) {
            formElementsArray.push({
                id: 'email',
                config: this.state.controls['email']
            });
        } else {
            for (let key in this.state.controls) {
                formElementsArray.push({
                    id: key,
                    config: this.state.controls[key]
                });
            }
        }

        let form = formElementsArray.map( (formElement, index) => (
            <Input
                focusOnShow={index === 0}
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                touched={formElement.config.touched}
                changed={(event) => this.inputChangedHandler( event, formElement.id )}
                required
            />
        ));
        if ( this.props.loading ) {
            form = <Spinner />
        }

        let errorMessage = null;
        if ( this.props.error ) {
            errorMessage = (
                <p style={{color: "red"}}>{this.props.error}</p>
            );
        }

        let responseMessage = null;
        if ( this.props.responseMessage && this.state.isPasswordReset) {
            responseMessage = (
                <p>{this.props.responseMessage}</p>
            );
        }

        // let authRedirect = null;
        // if ( this.props.isAuthenticated && !this.props.shouldRedirect ) {
        //     authRedirect = <Redirect to={this.props.authRedirectPath} />
        // }

        const passwordResetButton = <Button
            clicked={this.passwordResetHandlerMode}
            btnType="Danger">Reset Password</Button>;

        let fullForm = "";
        if (!this.props.responseMessage) {
            fullForm = (
                <form onSubmit={(this.state.isPasswordReset ? this.submitPasswordResetHandler : this.submitHandler)}>
                    {form}
                    <div className={"auth-button-container"}>
                        <Button btnType="Success">SUBMIT</Button>
                        <Button
                            clicked={this.switchAuthModeHandler}
                            btnType="Danger"
                        >{this.state.isSignup ? 'BACK TO LOGIN' : 'REGISTER NEW USER'}</Button>
                        {this.state.isPasswordReset ? '' : passwordResetButton}
                    </div>
                </form>
            );
        } else {
            fullForm = <><p>{this.props.responseMessage}</p>
                <div className={"auth-button-container"}>
                    <Button clicked={this.backToLogin} btnType="Danger">BACK TO LOGIN</Button>
                </div>
            </>
        }

        return (
            <>
                <div style={{width: "500px"}}></div> {/* This feels like cheating, but it actually seems to work very well. */}
                <div className="Auth">
                    <h3>{this.state.isPasswordReset ? 'RESET PASSWORD REQUEST' : (this.state.isSignup ? 'REGISTER NEW USER' : 'LOGIN')}</h3>
                    {/*{authRedirect}*/}
                    {errorMessage}
                    {responseMessage}
                    {fullForm}
                    <div className='eula'>
                        When you login to the site you agree to abide by the &nbsp;
                        <a href="https://perspectivesingamedesign.com/pattern-library-usage-agreement-769d20a27c5c" target="_blank" rel="noopener noreferrer">
                            Pattern Library Usage Agreement</a>. Failure to follow these guidelines may result in account deactivation.
                    </div>

                </div>
                { !this.props.hideDragon &&
                <section>
                    <div className={classes.dragon}><img src={apiUrl +"Images/Dragon-rotated.png"} width="200px" alt="Pattern Dragon"/></div>
                </section>}
            </>
        );
    }
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        responseMessage: state.auth.responseMessage,
        isAuthenticated: state.auth.token !== null,
        userId: state.auth.userId,
        authRedirectPath: state.auth.authRedirectPath,
        authLevel: state.auth.authLevel
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onAuth: ( email, password, isSignup ) => dispatch( actions.auth( email, password, isSignup ) ),
        onPasswordResetRequest: ( email ) => dispatch( actions.passwordResetRequest( email ) ),
        onSetAuthRedirectPath: () => dispatch( actions.setAuthRedirectPath( '/' ) ),
        onBackToLogin: () => dispatch(actions.backToLogin())
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Auth );